import styled, { css } from "styled-components";

export const MainDiv = styled.div<{
  $clickableRows?: boolean;
  $embedded?: boolean;
  $height?: string;
}>`
  height: ${(p) => p.$height ?? (p.$embedded ? "auto" : "57vh")};
  background-color: ${(p) => (p.$embedded ? "transparent" : "white")};
  width: 100%;
  display: flex;
  border-radius: ${(p) => (p.$embedded ? "0" : "10px")};

  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus,
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: red !important;
  }

  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within,
  .MuiDataGrid-root .MuiDataGrid-cell:focus-within {
    outline: none !important;
  }

  .MuiDataGrid-cell {
    border: none !important;
  }
  .MuiDataGrid-root {
    border: none !important;
  }

  svg.MuiSvgIcon-root.MuiDataGrid-iconSeparator {
    display: none;
  }

  ${(p) =>
    p.$clickableRows &&
    css`
      .MuiDataGrid-row {
        cursor: pointer;
      }
    `}
`;
